import React from "react";

const AdminPageAddGroupIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_5114_17199)">
        <path
          d="M13.8967 15.7311C13.3099 15.3217 12.6827 14.9881 12.0269 14.7332C12.8994 13.9402 13.4782 12.8293 13.5789 11.5856C14.902 10.2964 16.6364 9.5896 18.4956 9.5896C19.9471 9.5896 21.3407 10.0267 22.5261 10.8534C22.9509 11.1497 23.535 11.0457 23.8313 10.6209C24.1274 10.1962 24.0234 9.61194 23.5988 9.31586C23.0119 8.90644 22.3846 8.573 21.7287 8.31793C22.6915 7.44287 23.2968 6.18109 23.2968 4.7807C23.2968 2.14453 21.1523 0 18.5161 0C15.8801 0 13.7356 2.14453 13.7356 4.7807C13.7356 6.17542 14.336 7.43262 15.2922 8.30731C15.1613 8.35767 15.0311 8.41095 14.9022 8.46772C14.3155 8.72589 13.764 9.0434 13.2511 9.4162C12.5438 7.65894 10.8217 6.41529 8.81427 6.41529C6.17828 6.41529 4.03357 8.55982 4.03357 11.1958C4.03357 12.5867 4.63067 13.8404 5.58172 14.7147C3.03894 15.6674 0.97717 17.7136 0.137814 20.3232C-0.140507 21.1886 0.00689328 22.1063 0.542294 22.8411C1.07769 23.5758 1.90606 23.9971 2.815 23.9971H10.9703C11.488 23.9971 11.9077 23.5774 11.9077 23.0596C11.9077 22.5419 11.488 22.1223 10.9703 22.1223H2.815C2.51196 22.1223 2.23584 21.9818 2.05731 21.7368C1.87878 21.4918 1.82971 21.1859 1.92236 20.8973C2.84887 18.0167 5.67456 16.0049 8.79376 16.0049C10.2451 16.0049 11.6389 16.442 12.8243 17.2687C13.2489 17.5649 13.8332 17.4608 14.1295 17.0361C14.4255 16.6115 14.3215 16.0272 13.8967 15.7311ZM18.5161 1.87482C20.1185 1.87482 21.422 3.17835 21.422 4.7807C21.422 6.38288 20.1185 7.68659 18.5161 7.68659C16.9139 7.68659 15.6102 6.38288 15.6102 4.7807C15.6102 3.17835 16.9139 1.87482 18.5161 1.87482ZM8.81427 8.28992C10.4166 8.28992 11.7202 9.59363 11.7202 11.1958C11.7202 12.7982 10.4166 14.1017 8.81427 14.1017C7.21191 14.1017 5.90838 12.7982 5.90838 11.1958C5.90838 9.59363 7.21191 8.28992 8.81427 8.28992ZM23.9999 19.5445C23.9999 20.0621 23.5803 20.4818 23.0624 20.4818H20.4847V23.0596C20.4847 23.5774 20.065 23.9971 19.5474 23.9971C19.0295 23.9971 18.6099 23.5774 18.6099 23.0596V20.4818H16.0321C15.5145 20.4818 15.0948 20.0621 15.0948 19.5445C15.0948 19.0267 15.5145 18.607 16.0321 18.607H18.6099V16.0292C18.6099 15.5116 19.0295 15.0919 19.5474 15.0919C20.065 15.0919 20.4847 15.5116 20.4847 16.0292V18.607H23.0624C23.5803 18.607 23.9999 19.0267 23.9999 19.5445Z"
          fill="url(#paint0_linear_5114_17199)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_5114_17199"
          x1="11.4199"
          y1="-4.41123"
          x2="11.4199"
          y2="26.1145"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5172EA" />
          <stop offset="1" stopColor="#7A5AEE" />
        </linearGradient>
        <clipPath id="clip0_5114_17199">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AdminPageAddGroupIcon;
